@import '@alfalab/core-components-vars/src/index.css';

:root {
    --list-header-description-opacity: 0.6;
}

.component {
    margin: var(--gap-24) var(--gap-12-neg) var(--gap-16);
    padding: var(--gap-8) var(--gap-12);
}

.description {
    opacity: var(--list-header-description-opacity);
}

.filled {
    background-color: var(--color-light-neutral-200);
}
